import { Container } from "@mui/material";

export default function NotFound() {
  return (
    <Container maxWidth="md" sx={{ textAlign: 'center', py: 4 }}>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </Container>
  );
}